<template>
    <div
        id="app"
    >
        <TopNavbar
            v-model="showNavbar"
        />
        <div>
            <Sidebar
                v-if="user"
                id="sidebar-1"
                v-model="showNavbar"
            />
            <main
                role="main"
                :class="(loggedIn) ? 'col-sm-none col-md-8 ml-md-auto col-lg-10 pt-3' : ''"
            >
                <custom-spinner
                    :loading="loading"
                />
                <router-view
                    v-if="!loading"
                    :class="(loggedIn) ? 'my-4' : ''"
                />
                <next-navbar />
            </main>
            <!--<footer class="text-center">
            <div class="mt-4"><img src="@/assets/logo/logo.svg" height="32"> Powered by MyHomeschoolGroup</div>
            </footer>-->
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import Sidebar      from "@/components/sidebar/Sidebar.vue";
import TopNavbar    from "@/components/navbar/TopNavbar.vue";
import CustomSpinner from '@/components/spinner/CustomSpinner.vue';
import NextNavbar from '@/components/navbar/NextNavbar.vue';

export default {
    components: { Sidebar, CustomSpinner, TopNavbar, NextNavbar },
    data() {
        return { showNavbar: false };
    },
    computed: mapState (["user", "loggedIn", "loading"])
}
</script>
<style scoped>
@import url(assets/hisacademy3.2.css);
  .h-100 {
    min-height: 100%;
  }
  #container {
    width: 100%;
    transition:   ease-out 0.16s;
    transform:    translate(0px, 0px);
  }
  #container.open  {
    /*width:        calc(100% + 125px);
    margin-left:  125px;
      */
    transition:       ease-in 0.16s;
    transform:        translate(125px, 0px);
    /*background-color: rgba(0, 0, 0, 0.1);*/
  }
  .tray-toggleable {
    display: block;
  }
  @media only screen and (min-width: 600px) {
    .tray-toggleable {
      display: none;
    }
    #container.open {
      width: calc(100% - 125px);
    }
  }
  
  .sidenav {
    height: 100%;
    width: 0;
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    background-color: #111;
    overflow-x: hidden;
    transition: 0.5s;
    padding-top: 60px;
  }

  .sidenav a {
    padding: 8px 8px 8px 32px;
    text-decoration: none;
    font-size: 25px;
    color: #818181;
    display: block;
    transition: 0.3s;
  }

  .sidenav a:hover {
    color: #f1f1f1;
  }

  .sidenav .closebtn {
    position: absolute;
    top: 0;
    right: 25px;
    font-size: 36px;
    margin-left: 50px;
  }

  #main {
    transition: margin-left .5s;
    padding: 16px;
  }

  @media screen and (max-height: 450px) {
    .sidenav {padding-top: 15px;}
    .sidenav a {font-size: 18px;}
  }

  .cursor-pointer:hover {
    cursor: pointer;
  }
</style>